export default __webpack_public_path__ + "static/media/32.609d5320.gif";